import { render } from "./swatches.vue?vue&type=template&id=7375f34c"
import script from "./swatches.vue?vue&type=script&lang=js"
export * from "./swatches.vue?vue&type=script&lang=js"

import "./swatches.vue?vue&type=style&index=0&id=7375f34c&lang=css"
script.render = render

export default script